import React from "react";

//MUI
import { Container, Tooltip, Typography, Stack, Button } from "@mui/material";

//Icons
import { InfoOutlined, Add } from "@mui/icons-material";

// Styles
import { styles as buttonStyles } from "Common/Styles/ButtonStyles";
import { textStyles, commonStyles } from "Common/Styles";
import { grey } from "Constants/ColourConstants";

const CardInfo = ({
  title,
  tooltipInfo,
  addButtonTitle,
  addButtonOnClick,
  isHeading = true,
  children,
}) => {
  return (
    <Container sx={commonStyles.cardContainer}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography sx={isHeading ? textStyles.title : textStyles.subtitle}>
          {title}
        </Typography>
        <Stack direction="row" alignItems="center" gap={1}>
          {addButtonTitle && (
            <Button
              variant="contained"
              sx={buttonStyles.greenActionButton}
              onClick={addButtonOnClick}
            >
              <Add />
              <Typography variant="button">{addButtonTitle}</Typography>
            </Button>
          )}
          <Tooltip title={tooltipInfo} arrow>
            <InfoOutlined sx={{ color: grey }} />
          </Tooltip>
        </Stack>
      </Stack>
      {children}
    </Container>
  );
};

export default CardInfo;
